"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.repliedManagerAssistant = exports.consumedManagerAssistantSeed = exports.askedManagerAssistant = exports.closedManagerAssistantPlanning = exports.openedManagerAssistantPlanning = exports.setManagerAssistantExpanded = exports.toggledManagerAssistant = void 0;
const initial_1 = __importDefault(require("@app/store/initial"));
const toolkit_1 = require("@reduxjs/toolkit");
const action_type_1 = __importDefault(require("../const/action-type"));
// The manager assistant column can only be collapsed, never closed — so the only state
// it carries is whether it's expanded. Persisted via the store whitelist
// (app/store/persist.js), which is why it lives in Redux rather than component state.
const managerAssistantSlice = (0, toolkit_1.createSlice)({
    name: 'managerAssistant',
    initialState: initial_1.default.managerAssistant,
    reducers: {
        toggledManagerAssistant: (state) => {
            state.expanded = !state.expanded;
        },
        setManagerAssistantExpanded: (state, action) => {
            state.expanded = action.payload;
        },
        // Auto-planner panel. Opening it expands the column too — every caller fires right
        // after createPlan() (or on finding an existing plan), and the old right-side sidebar
        // it replaces used to pop open on its own in exactly those spots.
        openedManagerAssistantPlanning: (state) => {
            state.planningOpen = true;
            state.expanded = true;
        },
        closedManagerAssistantPlanning: (state) => {
            state.planningOpen = false;
        },
        // Starts a new chat with `prompt` as the manager's first message, expanding the column
        // so they see it happen.
        askedManagerAssistant: (state, action) => {
            state.seedPrompt = action.payload;
            state.expanded = true;
        },
        consumedManagerAssistantSeed: (state) => {
            state.seedPrompt = undefined;
        },
        // A reply from the agent has finished. Pages showing data the agent can change react to the
        // timestamp changing.
        repliedManagerAssistant: (state) => {
            state.lastReplyAt = Date.now();
        },
    },
    extraReducers: (builder) => {
        // A plan belongs to one workspace, so the panel must not survive a switch or a store
        // reset — same two cases the old `sidebar` slice reset on.
        builder
            .addCase(action_type_1.default.SWITCH_WORKSPACE, (state) => {
            state.planningOpen = false;
            state.seedPrompt = undefined;
        })
            .addCase(action_type_1.default.RESET_STORE, (state) => {
            state.planningOpen = false;
            state.seedPrompt = undefined;
        });
    },
});
_a = managerAssistantSlice.actions, exports.toggledManagerAssistant = _a.toggledManagerAssistant, exports.setManagerAssistantExpanded = _a.setManagerAssistantExpanded, exports.openedManagerAssistantPlanning = _a.openedManagerAssistantPlanning, exports.closedManagerAssistantPlanning = _a.closedManagerAssistantPlanning, exports.askedManagerAssistant = _a.askedManagerAssistant, exports.consumedManagerAssistantSeed = _a.consumedManagerAssistantSeed, exports.repliedManagerAssistant = _a.repliedManagerAssistant;
exports.default = managerAssistantSlice.reducer;
